<template>
  <div class="d-flex justify-content-center align-items-center mt-3 mb-3" :class="{'vh-100':!notFull}">
    <div class="spinner-border spinner text-black-50" role="status"></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: ['notFull']
}
</script>

<style scoped>

</style>